import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, Optional, PLATFORM_ID } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import * as cryptoJs from 'crypto-js'; // Import the crypto-js library
import { DOCUMENT } from '@angular/common';
import { SERVER_DATA } from "../tokens/server-data.token";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SharedService {
  public metaMultimedia$ = new BehaviorSubject<any>({
    meta: null,
    type: '',
    isEnabled: false
  });  
  public loaderFlag$ = new BehaviorSubject<any>({
    value: false,
    startImediate: false,
  });
  public loaderFlagWithMsg$ = new BehaviorSubject<any>({
    value: false,
    startImediate: false,
  });
    public toastFlag$ = new BehaviorSubject<any>({
    value: false,
    startImediate: false,
  });
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    @Optional() @Inject('REQUEST_ORIGIN') private origin: string,
    @Optional() @Inject(SERVER_DATA) private serverData: any    
  ) {}

  enableFullLoader(startImediate: boolean = false) {
    this.loaderFlag$.next({ value: true, startImediate: startImediate });
  }

  disableFullLoader() {
    this.loaderFlag$.next({ value: false, startImediate: false });
    this.disableFullLoaderInitial();
  }

  enableFullLoaderWithMsg(msg: string = "") {
    this.loaderFlagWithMsg$.next({ value: true, startImediate: false, msg: msg });
  }

  disableFullLoaderWithMsg() {
    this.loaderFlagWithMsg$.next({ value: false, startImediate: false, msg: '' });
    this.disableFullLoaderInitial();
  }


  enableToast(msg: string = "", toastType: string = "green") {
    // toastType => green / red
    this.toastFlag$.next({ value: true, startImediate: false, msg: msg, toastType: toastType });
  }

  disableToast() {
    this.toastFlag$.next({ value: false, startImediate: false, msg: '', toastType: '' });
  }
  

  disableFullLoaderInitial() {
    if (typeof window === "undefined") return;
    const fullLoaderInitialLandingEle = document.querySelector(
      ".full-loader-initial-landing"
    );
    if (fullLoaderInitialLandingEle)
      fullLoaderInitialLandingEle.classList.add("hidden");
  }

  vistNode(category: string, id: string) {
    if (isPlatformBrowser(this.platformId)) {
      let savedData = localStorage.getItem(category)
        ? JSON.parse(localStorage.getItem(category) || "")
        : [];
      savedData.push(id);
      localStorage.setItem(category, JSON.stringify(savedData));
    }
  }

  isVistedNode(category: string, id: string) {
    if (isPlatformBrowser(this.platformId)) {
      let savedData = localStorage.getItem(category)
        ? JSON.parse(localStorage.getItem(category) || "")
        : [];
      return savedData.some((item: any) => item === id) || false;
    }
  }

  isValidImage(img: string) {
    return img && img !== "00000000-0000-0000-0000-000000000000" ? img : null;
  }

  isExternalMethod(link: string) {
    if (!link) return false;
    if (
      link.startsWith("//") ||
      link.startsWith("http://") ||
      link.startsWith("https://") ||
      link.startsWith("www.")
    ) {
      return true;
    }
    return false;
  }

  encryptAmount(amount: string): string {
    const secretKey = 'qjet';
    const ciphertext = cryptoJs.AES.encrypt(amount, secretKey).toString();
    return encodeURIComponent(ciphertext); // Safe for URLs
  }
  
  decryptAmount(encrypted: any): string {
    const secretKey = 'qjet';
    const bytes = cryptoJs.AES.decrypt(decodeURIComponent(encrypted), secretKey);
    return bytes.toString(cryptoJs.enc.Utf8);
  }  


  getDomainURL(){
    if (isPlatformBrowser(this.platformId)) {
      const locationObj = window.location;
      const pathSegments = locationObj.pathname.split('/').filter(Boolean); // removes empty strings
      const firstPathSegment = pathSegments?.[0];
      const baseDomain = pathSegments.length > 0 ? `${locationObj.origin}${firstPathSegment === 'en' || firstPathSegment === 'ar' ? '' : ('/' + firstPathSegment)}` : locationObj.origin;

      return baseDomain;
    }else{
      return !environment.production ? 'http://localhost:4200' : this.serverData.domainURL;
    }
  }

}
